import React from "react";
import { useObserver } from "mobx-react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@material-ui/core";
import { ConfirmDialogStore } from "./ConfirmDialogStore";
import { Spinner } from "@components";
import Button from "@material-ui/core/Button";

type Props = {
  store: ConfirmDialogStore;
};

export function ConfirmDialog(props: Props) {
  const { store } = props;

  return useObserver(() => {
    const { options } = store;

    let content = null;

    if (store.open && store.options) {
      content = (
        <>
          <DialogTitle style={{ whiteSpace: "pre-line" }}>{options.title}</DialogTitle>

          {options.message && (
            <DialogContent>
              <DialogContentText>{options.message}</DialogContentText>
            </DialogContent>
          )}

          <DialogActions style={{ justifyContent: "space-between" }}>
            {props.store.options.actions.map((action) => {
              return (
                <Button
                  color={action.type === "primary" ? "primary" : "default"}
                  key={action.value}
                  onClick={() => store.onClick(action.value)}
                  style={action.style}
                  startIcon={action.icon}
                  variant="contained"
                  disabled={action.disabled ?? false}
                >
                  {action.title}
                </Button>
              );
            })}
          </DialogActions>
        </>
      );
    }

    const closeAction = store.options?.actions.find((action) => action.isClose);

    return (
      <Dialog
        open={store.open}
        {...(options && options.dialogProps)}
        onClose={closeAction ? () => store.onClick(closeAction.value) : undefined}
        TransitionProps={{ mountOnEnter: true, unmountOnExit: true }}
      >
        {content || <Spinner />}
      </Dialog>
    );
  });
}
